<template>
  <div
    v-if="message.needAck"
    :class="{'chat-message-confirmation--active' : !message.ack && !isMessageOwner}"
    class="chat-message-confirmation"
    @click="!message.ack && !isMessageOwner && $emit('ackMessage')"
  >
    <div v-if="isMessageOwner">
      <v-icon
        :color="message.ack ? 'accent' : 'bhWhite'"
        size="16"
      >
        mdi-check-circle
      </v-icon> {{ message.ack ? 'Acknowledgment approved' : 'You asked for acknowledgment of receipt of the message' }}
    </div>
    <div v-else>
      <v-icon
        :color="message.ack ? 'accent' : 'bhWhite'"
        size="16"
      >
        mdi-check-circle
      </v-icon> {{ message.ack ? 'Acknowledgment sent' : 'You have been asked for acknowledgment of receipt of the message' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatMessageConfirmation',
  props: {
    isMessageOwner: {
      type: Boolean,
      default: false
    },
    message: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.chat-message-confirmation {
  padding: 0.75*$gutter $gutter;
  line-height: 16px;
  font-size: 11px;
  color: $bh-black;
  border-radius: 0.5*$gutter;

  &--active {
    cursor: pointer;
    background-color: $bh-blue;
    color: $bh-white;
    &:hover {
      background-color: $bh-blue--2;
    }
  }
}
</style>
